import {
    SET_RENTING_RED_RAC_LIST,
    REMOVE_RENTING_RED_RAC_VEHICLE,
} from '../actions/types';

const initialAuctionsState = {
    vehicles: [],
};

const rentingRedRacReducer = (
    state = initialAuctionsState,
    { payload, type }
) => {
    switch (type) {
        case SET_RENTING_RED_RAC_LIST:
            return {
                ...state,
                vehicles: payload,
            };
        case REMOVE_RENTING_RED_RAC_VEHICLE:
            return {
                ...state,
                vehicles: state.vehicles.filter(
                    vehicle => vehicle?.Id !== payload
                ),
            };
        default:
            return state;
    }
};

export default rentingRedRacReducer;
